import { wpFetchRestApi, isWpSuccess } from "../util";
export function isError(status) {
    return 'error' in status;
}
export async function fetchStatus() {
    const res = await wpFetchRestApi("instachat", "GET");
    if (!isWpSuccess(res)) {
        throw new Error(res.errorData);
    }
    return res.data.state;
}
export async function sendState(state) {
    const res = await wpFetchRestApi("instachat/state", "POST", {
        state
    });
    if (!isWpSuccess(res)) {
        throw new Error(res.message);
    }
    return res.data.state;
}
;
